import * as React from 'react';
import { IAttendeeRegistrationListItem, IAttendeeRegistrationListItemSelected } from '../../../../../Models/Event/IAttendeeRegistrationListItem';
import { AttendeeRegistrationListView } from './AttendeeRegistrationListView';
import { useBoolean, useId } from '@fluentui/react-hooks';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import * as Services from '../../../../../Services/Services';
import { IEventApi } from '../../../../../Services/API/Event/IEventApi';
import { ActionButton, DefaultButton, Dialog, DialogFooter, Label, MessageBar, MessageBarType, PrimaryButton, ProgressIndicator, Stack, Text, Toggle } from '@fluentui/react';
import { PageTitle } from '../../../../PageTitle';
import { AttendeeRegistrationDetail } from '../AttendeeRegistrationDetail/AttendeeRegistrationDetail';
import { AddAttendeeRegistration } from '../AddAttendeeRegistration/AddAttendeeRegistration';
import { IUserProfile } from '../../../../../Models/Profile/IUserProfile';
import { IInvoiceApi } from '../../../../../Services/API/Invoice/IInvoiceApi';
import { ICreateInvoiceFromRegistration } from '../../../../../Models/Invoice/ICreateInvoiceFromRegistration';
import { dateToCZStr, getAge } from '../../../../../Tools/DateTime';


interface IAttendeeRegistrationListProps {
    eventId: number;
    eventName: string;
    showTitle: boolean
    profile: IUserProfile;
}



export const AttendeeRegistrationList: React.FunctionComponent<IAttendeeRegistrationListProps> = (props) => {
    const [attendeeRegistrationList, setAttendeeRegistrationList] = React.useState<IAttendeeRegistrationListItem[]>([]);
    const [filteredAttendeeRegistrationList, setFilteredAttendeeRegistrationList] = React.useState<IAttendeeRegistrationListItem[]>([]);

    const [itemInvoiceSelected, setItemInvoiceSelected] = React.useState<IAttendeeRegistrationListItemSelected[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isPropertiesOpened, setIsPropertiesOpened] = useBoolean(false);
    const [selectedAttendeeRegistration, setAttendeeRegistration] = React.useState<IAttendeeRegistrationListItemSelected>()
    const [isRegistrationDetailOpen, setIsRegistrationDetailOpen] = useBoolean(false);

    const [onlyActiveFilter, setOnlyActiveFilter] = React.useState(true);

    const [isAddAttendeeOpened, setIsAddAttendeeOpened] = useBoolean(false);

    const [openCreateInvoceDialog, setOpenCreateInvoceDialog] = useBoolean(false);
    const [sendInvoice, setSendInvoice] = React.useState(true);

    React.useEffect(() => {
        if (onlyActiveFilter === true) {
            setFilteredAttendeeRegistrationList(attendeeRegistrationList.filter(x => x.isActive === true));
        }
        else {
            setFilteredAttendeeRegistrationList(attendeeRegistrationList);
        }

    }, [attendeeRegistrationList, onlyActiveFilter])


    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const eventAttendee = await eventApi.getEventRegistrationsWithInvoice(props.eventId)

        if (eventAttendee.isSuccess && eventAttendee.data) {
            setAttendeeRegistrationList(eventAttendee.data);
        }
        else {
            setStatusMessage({ message: eventAttendee.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();

    }

    React.useEffect(() => {         
        setItemInvoiceSelected(filteredAttendeeRegistrationList.map(item => {
            return {
                ...item,
                priceInvoiceSelected: false,
                priceFirstSemesterInvoiceSelected: false,
                priceSecondSemesterInvoiceSelected: false,
                canCreatePriceInvoice: item.price > (item.priceInvoiceTotal ? item.priceInvoiceTotal : 0),
                canCreateFirstPriceInvoice: item.firstSemesterPrice > (item.firstSemesterPriceInvoiceTotal ? item.firstSemesterPriceInvoiceTotal : 0),
                canCreateSecondPriceInvoice: item.secondSemesterPrice > (item.secondSemesterPriceInvoiceTotal ? item.secondSemesterPriceInvoiceTotal : 0)
            }
        }));
    }, [filteredAttendeeRegistrationList])



    React.useEffect(() => {
        loadData();
    }, [])

    React.useEffect(() => {
        if (selectedAttendeeRegistration) {
            setIsRegistrationDetailOpen.setTrue();
        }
    }, [selectedAttendeeRegistration])

    const openDetail = (item: IAttendeeRegistrationListItemSelected)=>
    {
        setAttendeeRegistration(item);
    }

    const isRegistrationDetailClose = () => {
        setIsRegistrationDetailOpen.setFalse();
        setAttendeeRegistration(undefined);
    }


    const InvoiceAllSelection = (selectFa: keyof IAttendeeRegistrationListItemSelected, fieldName: string, value: boolean) => {
        let new_array = itemInvoiceSelected.map(element => element[selectFa] === true ? { ...element, [fieldName]: value } : element);
        setItemInvoiceSelected(new_array);
    }


    const InvoiceSelection = (registrationId: number, fieldName: string, value: boolean) => {
        let new_array = itemInvoiceSelected.map(element => element.id == registrationId ? { ...element, [fieldName]: value } : element);
        setItemInvoiceSelected(new_array);
    }

    const refresh = (items?: number[]) => {
        loadData();
    }

    const sendViaEmail = async (invoices: number[]) => {
        setIsLoading.setTrue();

        const invoiceApi = Services.ServicesProvider.GetService<IInvoiceApi>(Services.InvoiceApi);
        const result = await invoiceApi.sendInvoiceEmail(invoices);
        if (result.isSuccess) {            
            setStatusMessage({ message: "Faktura byla úspěšně odeslána emailem", type: MessageBarType.success });
            return true;
        }
        else {
            return false;
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const createInvoices = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const invoiceApi = Services.ServicesProvider.GetService<IInvoiceApi>(Services.InvoiceApi);
        const invoices: ICreateInvoiceFromRegistration[] = [];

        for (let i = 0; i < itemInvoiceSelected.length; i++) {
            const item = itemInvoiceSelected[i];
            if (item.priceInvoiceSelected) {
                invoices.push({ registrationId: item.id, semester: 0, value: item.price - (item.priceInvoiceTotal ? item.priceInvoiceTotal : 0), sendByEmail: sendInvoice })
            }
            if (item.priceFirstSemesterInvoiceSelected) {
                invoices.push({ registrationId: item.id, semester: 1, value: item.firstSemesterPrice - (item.firstSemesterPriceInvoiceTotal ? item.firstSemesterPriceInvoiceTotal : 0), sendByEmail: sendInvoice })
            }
            if (item.priceSecondSemesterInvoiceSelected) {
                invoices.push({ registrationId: item.id, semester: 2, value: item.secondSemesterPrice - (item.secondSemesterPriceInvoiceTotal ? item.secondSemesterPriceInvoiceTotal : 0), sendByEmail: sendInvoice })
            }
        }
        const eventAttendee = await invoiceApi.createInvoiceFromRegistration(invoices);

        if (eventAttendee.isSuccess && eventAttendee.data) {
            if (sendInvoice === true) {
                await sendViaEmail(eventAttendee.data);
            }
            refresh();
            setOpenCreateInvoceDialog.setFalse();
        }
        else {
            setStatusMessage({ message: eventAttendee.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const sendInvoiceChanged = (event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        setSendInvoice(checked ? checked : false);
    }
    
    const exportToCsv = () => {
        let csvContent = "\uFEFF Jméno;Příjmení;Email;Telefon;Ulice;Město;Datum;Věk;\n";

        attendeeRegistrationList.forEach((item) => {

            let row = `${item.firstName};${item.lastName};${item.emailAttendee ? item.emailAttendee : item.email};${item.phoneNumber};${item.street};${item.city};${dateToCZStr(item.dateOfBirth)};${getAge(item.dateOfBirth)}`;         
            csvContent = csvContent + row + "\n";
        });
        var link = document.createElement("a");
        const url = URL.createObjectURL(new Blob([csvContent], {
            type: "data:text/csv;charset=utf-8"
        }));
        link.setAttribute("href", url);
        link.setAttribute("download", "prihlaseniZaci.csv");
        document.body.appendChild(link); // Required for FF
        link.click();
        link.remove();
        setIsLoading.setFalse();
    }

    return (
        <Stack>
            {props.showTitle ?
                <>
                    <PageTitle title="Přihlášení žáci" />
                </>
                : null}
            <AttendeeRegistrationListView
                createInvoices={setOpenCreateInvoceDialog.setTrue}
                profile={props.profile}
                addNewRegistration={setIsAddAttendeeOpened.setTrue}
                onlyActiveFilter={onlyActiveFilter}
                setOnlyActiveFilter={setOnlyActiveFilter}
                invoiceAllSelection={InvoiceAllSelection}
                invoiceSelection={InvoiceSelection}
                items={itemInvoiceSelected}
                isLoading={isLoading}
                statusMessage={statusMessage}
                openDetail={openDetail}
                exportToCsv={exportToCsv}
            />

            <AttendeeRegistrationDetail refresh={loadData}
                profile={props.profile}
                eventName={props.eventName}
                item={selectedAttendeeRegistration}
                isOpen={isRegistrationDetailOpen}
                close={isRegistrationDetailClose} />
            {statusMessage ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}

            {isAddAttendeeOpened ?
                <AddAttendeeRegistration eventId={props.eventId} refresh={refresh} isOpened={isAddAttendeeOpened} onDismiss={setIsAddAttendeeOpened.setFalse} />
                : null}

            {openCreateInvoceDialog ?
                <Dialog title="Potvrďte vytvoření faktur" hidden={!openCreateInvoceDialog} onDismiss={setOpenCreateInvoceDialog.setFalse} modalProps={{ isBlocking: true }}>
                    <Label>Opravdu chcete vytvořit faktury na vybrané registrace?</Label>
                    
                    <Toggle disabled={isLoading} label="Mají se faktury odeslat emailem po vytvoření?" checked={sendInvoice} defaultChecked onText="ano" offText="ne" onChange={sendInvoiceChanged} />
                    {isLoading ? <ProgressIndicator></ProgressIndicator> : null}
                    
                    <DialogFooter>
                        <Stack horizontal tokens={{ childrenGap: 15 }}>
                            <PrimaryButton disabled={isLoading} styles={{ root: { width: 200 } }} onClick={createInvoices} text="Vytvořit fakturu(y)" />
                            <DefaultButton disabled={isLoading} onClick={setOpenCreateInvoceDialog.setFalse} text="Zrušit" />
                        </Stack>
                    </DialogFooter>
                </Dialog>
             :null}
            </Stack>
        )
}


